import React from 'react';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper'

import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

import NearMe from '@material-ui/icons/NearMe';
import Language from '@material-ui/icons/Language';
import Label from '@material-ui/icons/Label';
import ColorLens from '@material-ui/icons/ColorLens';
import Dashboard from '@material-ui/icons/Dashboard';

//import queryString from 'query-string'

import RxMyLabels from '../containers/RxMyLabels';
import RxMyCustomForm from '../containers/RxMyCustomForm';
import RxMyActivitiesList from '../containers/RxMyActivitiesList';
import RxFamousRacesList from '../containers/RxFamousRacesList';
import RxMyTemplates from '../containers/RxMyTemplates';

import RxPoster from '../containers/RxPoster';

import queryString from 'query-string';

import store from '../index';
import AddCartButton from './AddCartButton'

import { GlobalHotKeys } from 'react-hotkeys';

const keyMap = {
	CREATE_IMG: "ctrl+shift+i",
};

class Editor extends React.Component {


	constructor(props) {
		super(props);

		var code = window.location.search.split('code=');

		this.state = {
			open: false,
			checkoutOpen: false,
			tabIndex: code.length > 1 ? 0 : 1,
			amountDigital: 5,
			amountPoster: 35,
			format: 'Poster',
			freeDisabled: false,
			freeCaption: 'Free Download (Low resolution)'
		};

		this.props.onFetchFamousRaces()

		if (code.length > 1) {
			var access_token = null;
			fetch('https://www.strava.com/oauth/token', {
				method: 'POST',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8' },
				body: "client_id=22661&client_secret=9a6d2eb310d96101944e0994ad8d4ed177aa1289&code=" + code[1]
			}
			).then(function (response) {
				return response.json();
			}).then(json => {
				console.log(json);
				access_token = json.access_token;
				if (access_token) {

					this.props.onChangeLabel("athlete", json.athlete.firstname + ' ' + json.athlete.lastname);
					this.props.onLogin(access_token);
					localStorage.setItem('refresh_token', json.refresh_token)
					localStorage.setItem('user', json.athlete.firstname + ' ' + json.athlete.lastname)
					console.log(this.props);
					this.props.onFetchActivities(access_token);

				} else {
					this.props.onLogout();
				}

			});
		} else if (localStorage.getItem('refresh_token')) {
			access_token = null;
			fetch('https://www.strava.com/oauth/token', {
				method: 'POST',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8' },
				body: "client_id=22661&client_secret=9a6d2eb310d96101944e0994ad8d4ed177aa1289&grant_type=refresh_token&refresh_token=" + localStorage.getItem('refresh_token')
			}
			).then(function (response) {
				return response.json();
			}).then(json => {
				console.log(json);
				access_token = json.access_token;
				if (access_token) {

					this.props.onChangeLabel("athlete", localStorage.getItem('user'));
					this.props.onLogin(access_token);
					localStorage.setItem('refresh_token', json.refresh_token)
					console.log(this.props);
					this.props.onFetchActivities(access_token);

				} else {
					this.props.onLogout();
				}

			});
		}
	}

	handlers = {
		CREATE_IMG: event => {
			console.log('CREATE_IMG');
			this.handleTest()
		}
	};

	handleTest = () => {
		console.log(store.getState())
		fetch(global.serverUrl + '/generatePoster', {
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json'
			},
			method: "POST",
			body: JSON.stringify(store.getState().poster)
		})
			.then(function (res) {
				console.log(res)
			})
			.catch(function (res) { console.log(res) })
		//this.downloadString(JSON.stringify(store.getState()),"application/json","config.json",)
	}

	downloadString = (text, fileType, fileName) => {
		var blob = new Blob([text], { type: fileType });

		var a = document.createElement('a');
		a.download = fileName;
		a.href = URL.createObjectURL(blob);
		a.dataset.downloadurl = [fileType, a.download, a.href].join(':');
		a.style.display = "none";
		document.body.appendChild(a);
		a.click();
		document.body.removeChild(a);
		setTimeout(function () { URL.revokeObjectURL(a.href); }, 1500);
	}

	handleChangeTab = (event, value) => {
		this.setState({ tabIndex: value });
	};

	handleClickOpen = () => {
		this.setState({ checkoutOpen: true });
	};

	handleClose = value => {
		this.setState({ checkoutOpen: false });
	};

	render() {

		const { tabIndex } = this.state;
		const parsed = queryString.parse(window.location.search);
		console.log('LOGGEDIN: ' + this.props.app.isLoggedIn)
		return (
			<div>
				<GlobalHotKeys keyMap={keyMap} handlers={this.handlers} />
				{
					parsed.mode === 'fs' && <RxPoster />}
				{
					parsed.mode !== 'fs' &&

					<div id='editor' style={{ overflowX: 'hidden', padding: 8 }}>
						{/*<div>
					<link xmlns='http://www.w3.org/1999/xhtml' rel="stylesheet" type="text/css" href={"theme/" + this.props.poster.style.theme + ".css"} />
				</div>*/}

						<Grid container justify="center" style={{ paddingTop: 80 }} spacing={2}>
							<Grid item>
								<Paper style={{
									height: this.props.poster.layout.height,
									width: this.props.poster.layout.width,
									marginBottom: 20
								}} elevation={1}>
									<RxPoster />
								</Paper>
							</Grid>

							<Grid item>
								<Paper style={{
									height: this.props.poster.layout.height - 46,
									maxWidth: 560,
									marginBottom: 10
								}} elevation={2}>

									<Tabs value={tabIndex} onChange={this.handleChangeTab} indicatorColor="primary"
										style={{ maxWidth: 560 }}>
										<Tab icon={<NearMe />}
											label="Activities" style={{ height: 64, minWidth: 106 }}>
										</Tab>
										<Tab icon={<Language />}
											label="Races" style={{ height: 64, minWidth: 106 }}>
										</Tab>
										<Tab icon={<Dashboard />}
											label="Template" style={{ height: 64, minWidth: 106 }}>
										</Tab>
										<Tab icon={<Label />}
											label="Labels" style={{ height: 64, minWidth: 106 }}>
										</Tab>
										<Tab icon={<ColorLens />}
											label="Customize" style={{ height: 64, minWidth: 106 }}>
										</Tab>
									</Tabs>
									{tabIndex === 0 && <RxMyActivitiesList />}
									{tabIndex === 1 && <RxFamousRacesList />}
									{tabIndex === 2 && <RxMyTemplates />}
									{tabIndex === 3 && <RxMyLabels />}
									{tabIndex === 4 && <RxMyCustomForm />}

								</Paper>
								<AddCartButton />
								{/*<Button variant="contained" disabled={this.state.freeDisabled} onClick={this.handleFreeDownload} style={{ width: 450, marginBottom: 0 }} >{this.state.freeCaption}</Button >
								<Button id="posterButton" onClick={() => { this.setState({ format: "Poster" }); this.handleClickOpen() }} variant="contained" color="primary" style={{ width: 450}}>Buy Poster (Enhanced Matte Paper - 12x16 in) - {this.state.amountPoster}.00$ </Button >
							<Button id="digitalButton" onClick={() => { this.setState({ format: "Digital" }); this.handleClickOpen() }} variant="contained" color="primary" style={{ width: 450, marginBottom: 10 }}>Buy Digital Download (High resolution) - {this.state.amountDigital}.00$</Button >
							*/}
							</Grid>
						</Grid>


					</div>}</div>
		)
	}
}

export default Editor;


// WEBPACK FOOTER //
// ./src/components/Editor.js